import React from "react";
import { ITkStepperProps } from "../../../type/componentsType/TkStepper";
import { Step, StepLabel, Stepper } from "@mui/material";
import "./_style.scss";

/**
 * ステッパー部品
 * TkStepperコンポーネントは、MUIのStepperコンポーネントを拡張したものです。
 * @param {string[]} step ステップのラベル
 * @param {number} activeStep 現在のステップ数
 * @return TkStepper ステッパー部品
 */
export const TkStepper: React.FC<ITkStepperProps> = (props) => {
  const { steps, activeStep = 0, savaStep, ...rest } = props;

  return (
    <Stepper
      data-testid="tkStepperForTest"
      activeStep={activeStep}
      alternativeLabel
      {...rest}
      className="tkStepperContainer"
    >
      {steps.map((label, index) => (
        <Step key={label}>
          <StepLabel
            className={`${
              !!savaStep && index === savaStep - 1 && activeStep <= savaStep - 1
                ? "saveItem"
                : ""
            }`}
          >
            {label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

export default TkStepper;
